<div class="start-column-container column-gap-0p5 pd-bttm-0p625 min-width-20 max-width-23">
  <ng-container  *ngFor="let item of textList" >
    <div *ngIf="textList" class="start-start-row-container row-gap-0p375 ">
      <div class="start-column-container pd-top-0p15625">
        <div class="circle margin-tp-negative-0p15625">
          <app-all-icons *ngIf="showIcons"
            [iconNameAndStyling]="'close.svg; icon-size-0p78125 '">
          </app-all-icons>
        </div>
      </div>
      <div class="max-width-26p34375">{{item}}</div>
    </div>
  </ng-container>
 </div> 
